import { render } from "./PagePanel.vue?vue&type=template&id=4d182aa3&scoped=true"
import script from "./PagePanel.vue?vue&type=script&lang=js"
export * from "./PagePanel.vue?vue&type=script&lang=js"

import "./PagePanel.vue?vue&type=style&index=0&id=4d182aa3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d182aa3"]])

export default __exports__